<template>
  <q-dialog :visible="isVisible" :title="title" width="700px" :innerScroll="false" :showFooter="false" @close="onCancel">
    <div class="content">
      <el-form :model="requestParam" :rules="rules" ref="requestParam" label-width="110px" size="small">
        <el-row>
          <el-col :span="24" align="left">
            <el-form-item label="超时导入类型" prop="planTime">
              <el-radio-group v-model="requestParam.importType">
                <el-radio label="month" v-if="isShowMonth">月预估调整超时</el-radio>
                <el-radio label="quarter" v-if="isShowQuarter">季度预估调整超时</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="月份" prop="planTime">
              <el-select v-model="requestParam.planTime" placeholder="">
                <el-option :label="planTime" :value="planTime"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="店铺" prop="storeId">
              <el-select v-model="requestParam.storeId" placeholder="">
                <el-option :label="item.label" :value="item.value" v-for="(item, index) in stores" :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="原因" prop="reason">
              <el-input v-model="requestParam.reason" type="textarea" :autosize="{ minRows: 3, maxRows: 6 }"></el-input>
            </el-form-item>
            <el-form-item label="附件" prop="goodsCode">
              <el-upload
                class="upload-demo"
                ref="upload"
                accept=".xls,.xlsx,.xls.ttt,.xlsx.ttt"
                :limit="1"
                action=""
                :http-request="httpRequest"
                :on-remove="handleRemove"
                :headers="headers"
                :file-list="fileList"
                :on-success="handleSuccess"
                :before-upload="beforeUpload"
              >
                <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                <el-button
                  style="margin-left: 10px"
                  v-loading.fullscreen.lock="fjLoading"
                  element-loading-text="数据导入中"
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.8)"
                  size="small"
                  type="success"
                  @click="checkFormValid"
                  >上传
                </el-button>
                <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且只能上传一个</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="footer">
      <el-button @click="onCancel" size="medium">取 消</el-button>
    </div>
  </q-dialog>
</template>

<script>
import { getToken } from '@/utils/auth';
import { mapState } from 'vuex' // 引入mapState
import moment from 'moment';
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      userName: state => state.user.name
    }),
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      return '预估调整量超时导入';
    },
    planTime() {
      return moment().month() + 1 + '月';
    },
    isShowMonth() {
      return moment().date() >= 1 && moment().date() <= 14;
    },
    isShowQuarter() {
      return moment().date() >= 16
    },
  },
  data() {
    return {
      loading: false,
      fjLoading: false,
      searchForm: {
        importType: '',
      },
      rules: {
        importType: [{ required: true, message: '不能为空', trigger: 'change' }],
        reason: [{ required: true, message: '不能为空', trigger: 'blur' }],
        planTime: [{ required: true, message: '不能为空', trigger: 'change' }],
        storeId: [{ required: true, message: '不能为空', trigger: 'blur' }],
      },
      headers: {
        Authorization: getToken(),
        fileType: 81,
      },
      tableData: {
        records: [],
        pageSize: 30,
        pageNum: 1,
        total: 0,
      },
      requestParam: {},
      visibleColumns: [],
      fileList: [],
      stores: [],
    };
  },
  methods: {
    onCancel() {
      this.isVisible = false;
      this.fileList = [];
    },
    // 根据月份获取店铺
    getMonthStore() {
      this.$q.preSalePlan
        .getMonthStore({
          params: {
            month: parseInt(this.requestParam.planTime),
          },
        })
        .then((res) => {
          if (res.code == 200) {
            this.stores = Object.keys(res.data).map((v) => {
              return {
                label: res.data[v],
                value: v,
              };
            });
            if (this.stores.length == 1) {
              this.requestParam.storeId = this.stores[0].value;
            }
          }
        });
    },
    handleRemove() {
      this.fileList = [];
    },
    httpRequest() {},
    handleSuccess(res) {
      if (res.code === 200) {
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
      this.cancel();
      this.handleSearch();
    },
    // 验证
    beforeUpload(file) {
      let pattern = file.name.substring(file.name.lastIndexOf('.') + 1);
      if (['xls', 'xlsx', 'xls.ttt', 'xlsx.ttt'].indexOf(pattern.toLowerCase()) === -1) {
        this.$message.error('请上传后缀名为.xls,.xlsx的附件！');
        return false;
      }
      this.fileList = [];
      this.fileList.push(file);
    },
    checkFormValid(file) {
      this.$refs['requestParam'].validate((valid) => {
        if (valid) {
          this.submitUpload(file);
        } 
      });
    },
    submitUpload() {
      if (!this.fileList || this.fileList.length === 0) {
        this.$message.error('请先上传附件');
        return;
      }
      this.fjLoading = true;
      this.fjLoading = true;
      let taskDTO = null;
      let fields = [
        {
          columnName: '店铺名称',
          columnValue: this.stores.find((v) => v.value === this.requestParam.storeId).label,
          fieldName: 'storeId',
          fieldValue: this.requestParam.storeId,
          relation: 'storeId',
        },
        {
          columnName: '超时导入月份',
          columnValue: parseInt(this.requestParam.planTime),
          fieldName: 'planTime',
          fieldValue: parseInt(this.requestParam.planTime),
          relation: 'planTime',
        },
        {
          columnName: '超时导入类型',
          columnValue: this.requestParam.importType == 'month' ? '月预估调整超时' : '季度预估调整超时',
          fieldName: 'prePlanAdjustImportType',
          fieldValue: this.requestParam.importType,
          relation: 'prePlanAdjustImportType',
        },
        //是否为超时导入
        {
          columnName: '',
          columnValue: '',
          fieldName: 'isTimeOutImport',
          fieldValue: 1,
          relation: 'isTimeOutImport',
        },
        // {
        //   columnName: '提报人',
        //   columnValue: 'userName',
        //   fieldName: 'userName',
        //   fieldValue: this.userName,
        //   relation: 'userName',
        // },
        // {
        //   columnName: '提报时间',
        //   columnValue: 'submitTime', 
        //   fieldName: 'submitTime',
        //   fieldValue: moment().format('YYYY-MM-DD HH:mm:ss'),
        //   relation: 'submitTime',
        // },
        {
          columnName: '原因',
          columnValue: this.requestParam.reason,
          fieldName: 'reason',
          fieldValue: this.requestParam.reason,
          relation: 'reason',
        },
      ];
      taskDTO = {
        reportName: 'prePlanGoodsTimeOutAdjust',
        appCode: 'ec-pc-new',
        paramMap: fields,
      };
      this.$q.common
        .uploadFile({
          data: {
            file: this.fileList[0],
            taskDTO: JSON.stringify(taskDTO),
          },
        })
        .then((res) => {
          if (res.success) {
            this.$message.success('数据导入中，请稍后');
            this.onCancel();
            this.$emit('success');
          }
        })
        .finally((_) => {
          this.fjLoading = false;
        });
    },
  },
  created() {
    this.$set(this.requestParam, 'planTime', this.planTime);
    this.isShowMonth && !this.isShowQuarter && this.$set(this.requestParam, 'importType', 'month');
    !this.isShowMonth && this.isShowQuarter && this.$set(this.requestParam, 'importType', 'quarter');
    this.getMonthStore();
  },
};
</script>

<style lang="stylus" scoped>
.header {
  display: flex;
  height: 40px;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
}

.footer {
  text-align: center;
  margin-top: 10px;
}

>>> .el-form-item--mini {
  width: 280px;
  margin-bottom: 0;
}

>>> .el-dialog {
  margin-top: 50px !important;
}
</style>
